import home from './home.json'
import pokemonCenter from './pokemon-center.json'
import gymEntrance from './gym-entrance.json'
import battleTower from './battle-tower.json'
import lfzEntrance from './lfz-entrance.json'
import casino from './casino.json'
import casinoRoom from './casino-room.json'
import homeHouse1 from './home-house-1.json'
import homeHouse2 from './home-house-2.json'
import homeHouse3 from './home-house-3.json'
import gymArena1PreBattle from './gym-arena-1-pre-battle.json'
import gymArena2PreBattle from './gym-arena-2-pre-battle.json'
import gymArena3PreBattle from './gym-arena-3-pre-battle.json'
import gymArena4PreBattle from './gym-arena-4-pre-battle.json'
import gymArena5PreBattle from './gym-arena-5-pre-battle.json'
import gymArena1PostBattle from './gym-arena-1-post-battle.json'
import gymArena2PostBattle from './gym-arena-2-post-battle.json'
import gymArena3PostBattle from './gym-arena-3-post-battle.json'
import gymArena4PostBattle from './gym-arena-4-post-battle.json'
import gymArena5PostBattle from './gym-arena-5-post-battle.json'
import gymArena6 from './gym-arena-6.json'
import npcData from './npc.json'
import dialogueData from './dialogue.json'
import generalQuestions from './general-questions.json'
import battleData from './battle.json'

const levels = {
  home,
  pokemonCenter,
  gymEntrance,
  battleTower,
  lfzEntrance,
  casino,
  casinoRoom,
  homeHouse1,
  homeHouse2,
  homeHouse3,
  gymArena1PreBattle,
  gymArena2PreBattle,
  gymArena3PreBattle,
  gymArena4PreBattle,
  gymArena5PreBattle,
  gymArena1PostBattle,
  gymArena2PostBattle,
  gymArena3PostBattle,
  gymArena4PostBattle,
  gymArena5PostBattle,
  gymArena6
}

export {
  levels,
  npcData,
  dialogueData,
  battleData,
  generalQuestions
}
